import { accountAnalyticAction } from "app/store/dashboard/account_analytic//actions/accountAnalyticAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  yearlyFilter: "current_year",
  deviceFilter: "all",
  accountFilter: "all",
};

const accountAnalyticSlice = createSlice({
  name: "accountAnalytic",
  initialState: initialState,
  reducers: accountAnalyticAction,
});

export const { changeFilter } = accountAnalyticSlice.actions;

export default accountAnalyticSlice.reducer;
